// rdesc comes as "Player#Method" — reference shows "Method by Player"
// (e.g. "Header Goal by Luis Suarez"); "No Goal" rounds have no player part.
function formatGoalResult(rdesc) {
  if (!rdesc) return '';
  const [player, method] = String(rdesc).split('#');
  if (!method) return player;
  return `${method} by ${player}`;
}

export default function GoalResult({ detail }) {
  return (
    <div className="d-flex justify-content-center">
      <div className="cricket20ballpopup cricket20ballresult goalresult">
        <img src="https://wver.sprintstaticdata.com/v230/static/admin/img/balls/soccer-ball.png" />
        {' '}
        <span>{formatGoalResult(detail?.rdesc)}</span>
      </div>
    </div>
  );
}
